import WebFont from "webfontloader";
import "./preload.css";

WebFont.load({
  custom: {
    families: ["neon"],
  },
});
